import { LegalLayout } from './LegalLayout';

export const PrivacyPage = () => (
  <LegalLayout title="Política de Privacidade" updated="14 de maio de 2026">
    <p>
      Esta Política descreve como o Pórtico coleta, usa, armazena e protege seus dados pessoais,
      em conformidade com a Lei Geral de Proteção de Dados (LGPD, Lei 13.709/2018).
    </p>

    <h2>1. Quem somos</h2>
    <p>
      O Pórtico é um serviço de renderização arquitetônica acessível em{' '}
      <a href="https://render.prospectar.site">render.prospectar.site</a>. Para fins de proteção
      de dados, somos controladores das informações que você nos fornece.
    </p>

    <h2>2. Dados que coletamos</h2>
    <h3>Quando você cria conta</h3>
    <ul>
      <li>Email</li>
      <li>Senha (armazenada como hash, nunca em texto puro)</li>
      <li>Data e hora do cadastro</li>
    </ul>
    <h3>Quando você usa a plataforma</h3>
    <ul>
      <li>Imagens que você envia para renderizar</li>
      <li>Imagens geradas pelo modelo</li>
      <li>Parâmetros escolhidos (tipo de ambiente, iluminação, estilo)</li>
      <li>Histórico de uso de créditos</li>
      <li>Dados técnicos: endereço IP, tipo de navegador, sistema operacional</li>
    </ul>
    <h3>Quando você assina um plano</h3>
    <p>
      A cobrança é feita pelo Asaas. Não armazenamos número de cartão. Receber confirmação de
      pagamento e identificador do pagador via webhook do Asaas. CPF/CNPJ é coletado pelo Asaas
      diretamente, conforme exigência fiscal para emissão de NFS-e.
    </p>

    <h2>3. Para que usamos seus dados</h2>
    <ul>
      <li><strong>Prestação do serviço:</strong> autenticar você, processar renders, controlar créditos.</li>
      <li><strong>Cobrança:</strong> processar pagamentos e emitir notas fiscais.</li>
      <li><strong>Comunicação:</strong> avisar sobre status do render, novidades, mudanças nos Termos.</li>
      <li><strong>Segurança:</strong> prevenir fraude, detectar abuso, manter logs por 6 meses.</li>
      <li><strong>Melhoria do produto:</strong> métricas agregadas e anônimas sobre uso.</li>
    </ul>

    <h2>4. Base legal (LGPD art. 7º)</h2>
    <ul>
      <li><strong>Execução de contrato:</strong> dados necessários para entregar o serviço.</li>
      <li><strong>Cumprimento de obrigação legal:</strong> retenção fiscal e fiscal NFS-e.</li>
      <li><strong>Legítimo interesse:</strong> segurança, prevenção de fraude e melhoria do produto.</li>
      <li><strong>Consentimento:</strong> emails de marketing e newsletter (opt-in explícito).</li>
    </ul>

    <h2>5. Com quem compartilhamos</h2>
    <p>Compartilhamos dados apenas com prestadores essenciais ao serviço:</p>
    <ul>
      <li><strong>Supabase</strong> (banco de dados, autenticação, storage) — servidores nos EUA, com cláusulas contratuais de proteção.</li>
      <li><strong>Replicate</strong> (processamento dos modelos de IA) — servidores nos EUA. Imagens são processadas e descartadas dos servidores deles após retorno.</li>
      <li><strong>Cloudflare</strong> (hospedagem da landing e CDN) — infraestrutura global.</li>
      <li><strong>Asaas</strong> (processador de pagamento) — servidores no Brasil.</li>
      <li><strong>Brevo</strong> (envio de emails transacionais) — servidores na Europa, conformidade GDPR/LGPD.</li>
      <li><strong>Meta</strong> (pixel publicitário) — apenas eventos agregados de visita e cadastro, sem CPF, email ou imagens.</li>
    </ul>
    <p>Não vendemos seus dados. Não compartilhamos para perfilamento de terceiros.</p>

    <h2>6. Por quanto tempo guardamos</h2>
    <ul>
      <li><strong>Dados de cadastro</strong>: enquanto sua conta estiver ativa + 6 meses após encerramento.</li>
      <li><strong>Imagens enviadas e renderizadas</strong>: armazenadas enquanto sua conta está ativa. Você pode apagar quando quiser. Removidas em até 30 dias após encerramento da conta.</li>
      <li><strong>Dados fiscais</strong>: 5 anos, conforme obrigação legal.</li>
      <li><strong>Logs de acesso</strong>: 6 meses.</li>
    </ul>

    <h2>7. Seus direitos (LGPD art. 18)</h2>
    <p>Você pode a qualquer momento:</p>
    <ul>
      <li>Confirmar quais dados temos sobre você.</li>
      <li>Acessar, corrigir ou completar dados incompletos.</li>
      <li>Anonimizar, bloquear ou eliminar dados desnecessários.</li>
      <li>Portar dados para outro serviço.</li>
      <li>Revogar consentimento.</li>
      <li>Reclamar à Autoridade Nacional de Proteção de Dados (ANPD).</li>
    </ul>
    <p>
      Para exercer qualquer direito, escreva para{' '}
      <a href="mailto:contato@portico.studio">contato@portico.studio</a>. Respondemos em até 15
      dias.
    </p>

    <h2>8. Segurança</h2>
    <p>
      Usamos HTTPS obrigatório, senhas em hash, controle de acesso por linha (RLS) no banco,
      isolamento de storage por usuário, autenticação JWT e logs de auditoria. Mesmo assim,
      nenhum sistema é 100% seguro. Em caso de incidente, comunicaremos você e a ANPD nos prazos
      previstos pela LGPD.
    </p>

    <h2>9. Crianças e adolescentes</h2>
    <p>
      O Pórtico não é direcionado a menores de 18 anos. Se descobrirmos que coletamos dados de
      menor sem consentimento adequado, apagamos imediatamente.
    </p>

    <h2>10. Cookies</h2>
    <p>
      Usamos cookies essenciais para login e cookies analíticos para entender uso da plataforma.
      Não usamos cookies de publicidade direcionada nem rastreamento entre sites.
    </p>

    <h2>11. Contato do encarregado (DPO)</h2>
    <p>
      <a href="mailto:contato@portico.studio">contato@portico.studio</a>
    </p>
  </LegalLayout>
);
